import { Observable } from 'rxjs';

/**
 * Tap into the stream to compare the previous/current values without side effects
 *
 * @example
 * this.searchState$.pipe(compareTap(([previous, current]) => {
 *   if (previous.term !== current.term) {
 *     this.trackerService.trackSearchTermChanged({
 *       termChangedFrom: previous.term,
 *       termChangedTo: current.term
 *     })
 *   }
 * }))
 */
export function compareTap(tapFn: CompareTapFn) {
  return function <T>(source: Observable<T>): Observable<T> {
    return new Observable((subscriber) => {
      let previous: T;
      let hasPrevious = false;
      return source.subscribe({
        next: (current) => {
          const p = previous;
          previous = current;
          hasPrevious && tapFn([p, current]);
          subscriber.next(current);
          hasPrevious = true;
        },
        error(error) {
          subscriber.error(error);
        },
        complete() {
          subscriber.complete();
        },
      });
    });
  };
}

export type CompareTapFn = <T>([previous, current]: [any, any]) => void;
